import { HttpMethod } from 'api/constants';
function returnPath(): string {
  return this.path;
}
function replaceSectionId(sectionId: string): string {
  return this.path.replace(':commuteSectionId', sectionId);
}
export const commuteSectionsEndpoints = {
  [HttpMethod.Get]: {
    All: {
      path: '/commute-sections',
      route: returnPath
    },
    ById: {
      path: '/commute-sections/:commuteSectionId',
      route: replaceSectionId
    },
    CommuteSectionResources: {
      path: '/commute-sections/:commuteSectionId/commute-resources',
      route: replaceSectionId
    },
    Draft: {
      path: '/commute-sections/:commuteSectionId/draft',
      route: replaceSectionId
    }
  },
  [HttpMethod.Post]: {
    CommuteSections: {
      path: '/commute-sections',
      route: returnPath
    },
    PublishDraft: {
      path: '/commute-sections/:commuteSectionId/draft/publish',
      route: replaceSectionId
    }
  },
  [HttpMethod.Put]: {
    Draft: {
      path: '/commute-sections/:commuteSectionId/draft',
      route: replaceSectionId
    }
  },
  [HttpMethod.Patch]: {
    ById: {
      path: '/commute-sections/:commuteSectionId',
      route(commuteSectionId: string): string {
        return this.path.replace(':commuteSectionId', commuteSectionId);
      }
    }
  },
  [HttpMethod.Delete]: {
    ById: {
      path: '/commute-sections/:commuteSectionId',
      route: replaceSectionId
    },
    Many: {
      path: '/commute-sections',
      route: returnPath
    },
    // Discard is a DELETE of the draft slot, not a POST /draft/discard.
    Draft: {
      path: '/commute-sections/:commuteSectionId/draft',
      route: replaceSectionId
    }
  }
};
export default commuteSectionsEndpoints;